import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { IPhoto } from '@bridebook/models/source/models/Suppliers/Photos.types';
import { Reviews } from '@bridebook/web/app-shared/lib/supplier/types';
import { memo } from 'react';
import { generateSupplierMicrodata } from '@bridebook/web/lib/utils/microdata-schema-generators/generate-supplier-microdata';

interface IProps {
  supplier: ISupplier;
  photos?: IPhoto[];
  canonicalUrl: string;
  metaDesc: string;
  reviews: Reviews;
  reviewsCount: number;
}

const SupplierMicrodata = ({
  supplier,
  canonicalUrl,
  metaDesc,
  reviews,
  reviewsCount,
  photos,
}: IProps) => {
  if (!supplier) return null;

  const data = generateSupplierMicrodata(
    supplier,
    canonicalUrl,
    metaDesc,
    reviews,
    reviewsCount,
    photos,
  );

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
    />
  );
};

export default memo(SupplierMicrodata);
